import { ClosedCaption } from "@mui/icons-material";
import { Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { getRequest, server } from "../../config";
const Contract = ({ onClose, visible, bookingId }) => {
  const [contracts, setcontracts] = useState([]);
  const [customerContract, setcustomerContract] = useState(null)
  const [partnerContract, setpartnerContract] = useState(null)
  useEffect(() => {
    fetchAllContracts();
  }, []);
  const fetchAllContracts = async () => {
    const res = await getRequest(
      `${server.uri}contracts?filter={"where":{"serviceRequestId":"${bookingId}"},"include":[{"relation":"serviceRequest"}]}`
    );
    if (res) {
        res?.map((item)=>{
            if(item?.createdBy=='customer'){
              setcustomerContract(item)
            }
            else{
              setpartnerContract(item)
            }
          })
    }
    setcontracts(res);
    console.log(res);
  };

  return (
    <Modal
      open={visible}
      onClose={onClose}
      aria-labelledby="modal-title"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxHeight: "900px",
      }}
      aria-describedby="modal-description"
    >
      <div className="bg-white h-[90%] p-10 w-1/2 rounded-md overflow-scroll">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            cursor: "pointer",
            alignItems: "center",
          }}
        >
          <Typography id="modal-title" variant="h4" component="h2">
            Booking Contract
          </Typography>
          <button onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <hr className="my-4" />
        <div>
          <Typography variant="h6" component="h4" className="mb-2">
            Customer Contract
          </Typography>
          {customerContract ? (
           <table>
            <tr>
                <td>Category</td>
                <td>{customerContract?.category}</td>
            </tr>
            <tr>
                <td> Estimated Days</td>
                <td>{customerContract?.estimatedDays}</td>
            </tr>
            <tr>
                <td> workDetails</td>
                <td>{customerContract?.workDetails}</td>
            </tr>
            <tr>
                <td> Estimate Amount :</td>
                <td>{customerContract?.amount}</td>
            </tr>
            <tr>
                <td> Customer</td>
                <td>{customerContract?.serviceRequest?.customerName}</td>
            </tr>
            <tr>
                <td> Status</td>
                <td>{customerContract?.status}</td>
            </tr>
            <tr>
                <td> BookingId</td>
                <td>{customerContract?.serviceRequest?.bookingId}</td>
            </tr>
            <tr>
                <td> Range</td>
                <td>{customerContract?.range}</td>
            </tr>
           </table>
          ) : (
            <Typography>No contract available for customer.</Typography>
          )}
          
          </div>
          <div className="mt-6">
          <Typography variant="h6" component="h4" className="mb-2">
            Partner Contract
          </Typography>
          {partnerContract ? (
            <table>
            <tr>
                <td>Category</td>
                <td>{partnerContract?.category}</td>
            </tr>
            <tr>
                <td> Estimated Days</td>
                <td>{partnerContract?.estimatedDays}</td>
            </tr>
            <tr>
                <td> workDetails</td>
                <td>{partnerContract?.workDetails}</td>
            </tr>
            <tr>
                <td> Estimate Amount :</td>
                <td>{partnerContract?.amount}</td>
            </tr>
            <tr>
                <td> Customer</td>
                <td>{partnerContract?.serviceRequest?.customerName}</td>
            </tr>
            <tr>
                <td> Status</td>
                <td>{partnerContract?.status}</td>
            </tr>
            <tr>
                <td> BookingId</td>
                <td>{partnerContract?.serviceRequest?.bookingId}</td>
            </tr>
            <tr>
                <td> Range</td>
                <td>{partnerContract?.range}</td>
            </tr>
           </table>
          ) : (
            <Typography>No contract available for partner.</Typography>
          )}
          </div>
      </div>

    </Modal>
  );
};

export default Contract;
